/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Capacity_SeatedInputs */

const en_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seated Capacity`)
};

const es_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad sentada`)
};

const fr_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité assise`)
};

const de_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzplatzkapazität`)
};

const ja_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`着席での収容人数`)
};

const zh_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`就座容量`)
};

const ar_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعة (جلوساً)`)
};

const id_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapasitas Duduk`)
};

const it_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capienza a Sedere`)
};

const ru_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вместимость (сидя)`)
};

const pt_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidade Sentado`)
};

const ko_field_capacity_seated = /** @type {(inputs: Field_Capacity_SeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좌석 수용 인원`)
};

/**
* | output |
* | --- |
* | "Seated Capacity" |
*
* @param {Field_Capacity_SeatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_capacity_seated = /** @type {((inputs?: Field_Capacity_SeatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Capacity_SeatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_capacity_seated(inputs)
	if (locale === "es") return es_field_capacity_seated(inputs)
	if (locale === "fr") return fr_field_capacity_seated(inputs)
	if (locale === "de") return de_field_capacity_seated(inputs)
	if (locale === "ja") return ja_field_capacity_seated(inputs)
	if (locale === "zh") return zh_field_capacity_seated(inputs)
	if (locale === "ar") return ar_field_capacity_seated(inputs)
	if (locale === "id") return id_field_capacity_seated(inputs)
	if (locale === "it") return it_field_capacity_seated(inputs)
	if (locale === "ru") return ru_field_capacity_seated(inputs)
	if (locale === "pt") return pt_field_capacity_seated(inputs)
	return ko_field_capacity_seated(inputs)
});